export default __webpack_public_path__ + "static/media/stat-latest-deal.2d19ca95.svg";